// import { coreConfig } from "../modules/core/config";

import moment from "moment-jalaali";

// const dd = (data) => {
// };

const differenceBy = (data, selected, title) => {
  const results = data.filter(
    ({ id: id1 }) => !selected.some(({ id: id2 }) => id2 === id1)
  );

  return results;
};

// convert english number to farsi
const toFarsiNumber = (num) => {
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  if (num) {
    return num
      .toLocaleString()
      .toString()
      .replace(/\d/g, (x) => farsiDigits[x]);
  } else {
    return (0)
      .toLocaleString()
      .toString()
      .replace(/\d/g, (x) => farsiDigits[x]);
  }
};

// get window size
const getWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};

// this must be custom hook

// // outside of components click handler
// const outSideClickHandler = (callback) => {
//   const loginForm = useRef();

//   useEffect(() => {
//     const handleClick = (event) => {
//       if (loginForm.current && !loginForm.current.contains(event.target)) {
//         callback();
//       }
//     };

//     document.addEventListener("click", handleClick, true);

//     return () => {
//       document.removeEventListener("click", handleClick, true);
//     };
//   }, [loginForm]);

//   return loginForm;
// };

// unique id generator
const idGenerator = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const getFormData = (e) => {
  const data = new FormData(e.target);
  const formObject = Object.fromEntries(data.entries());

  return formObject;
};

const translateLabel = (fa, label) => {
  return fa[label];
};

// limit string character
const limitString = (msg, character) => {
  let message;
  if (msg?.length > character) {
    message = msg.substring(0, character);
    return message + "...";
  } else {
    message = msg;
    return msg;
  }
};

const getChildrens = (rootCat) => {
  if (!rootCat.hasOwnProperty("name")) throw new Error("isnt root category");
  const root = {
    key: rootCat.id,
    parent_id: rootCat.parent_id,
    label: rootCat.name,
    data: `${rootCat.name}-data`,
    children: [],
  };

  if (rootCat.hasOwnProperty("children")) {
    const newChilds = [];
    rootCat.children.forEach((child) => {
      newChilds.push(getChildrens(child));
    });

    root.children = newChilds;
  }

  return root;
};

const tagsObject = (tags) => {
  const newTag = [];

  tags.forEach((tag) => {
    newTag.push({
      key: tag.id,
      label: tag.name ? tag.name : tag.title,
      slug: tag.slug,
    });
  });

  return newTag;
};

const dropDownObject = (object, ticket, pack) => {
  const newObj = [];
  object.forEach((obj, i) => {
    if (obj !== null) {
      newObj.push({
        code: ticket ? i : obj.id,
        name: ticket ? obj.name_fa : pack ? obj.title : obj.name,
        ...(pack && { ...obj }),
      });
    }
  });

  return newObj;
};

const priceObject = (prices, ticket) => {
  const newObj = [];

  prices.forEach((price, i) => {
    newObj.push({
      code: price.time,
      name: toFarsiNumber(price.time) + " " + "ماهه",
      ...price,
    });
  });

  return newObj;
};

const accessObject = (tags, ticket) => {
  const newAccess = [];

  tags.forEach((tag, i) => {
    newAccess.push({
      key: ticket ? i : tag.name,
      label: tag.name_fa,
    });
  });

  return newAccess;
};

const selectedAccess = (items) => {
  const newItems = {};
  items &&
    items.forEach((item) => {
      newItems[item] = true;
    });

  return newItems;
};

const selectedItems = (items, lesson, teacher, test, cat, pattern, product) => {
  const newItems = {};
  items &&
    items.forEach((item) => {
      const id = cat
        ? item.category_id
        : teacher
        ? item.teacher_id
        : lesson
        ? item.lesson_id
        : test
        ? item.test
        : pattern
        ? item.pattern_id
        : product
        ? item.product_id
        : item.id;
      newItems[id] = true;
    });

  return newItems;
};

const selectedRankItem = (ranks) => {
  const newItems = {};
  ranks &&
    ranks.forEach((item) => {
      const id = item.rank;
      newItems[id] = true;
    });

  return newItems;
};

const randomColor = () => {
  const color = Math.floor(Math.random() * 16777215).toString(16);

  return color;
};

const ReservedTimes = (allTimes, selectedTimes) => {
  const reserved = [];

  allTimes.forEach((all) => {
    all.times.forEach((time) => {
      if (selectedTimes[time.time_id] === true) {
        reserved.push(time.time_id);
      }
    });
  });

  return reserved;
};

const ticketCatObject = (ticket, to) => {
  const newTag = [];

  ticket.forEach((tick, i) => {
    newTag.push({
      key: to ? tick.id : i,
      label: tick.name_fa,
    });
  });

  return newTag;
};

const addressObject = (add) => {
  const newTag = [];

  add.forEach((a, i) => {
    newTag.push({
      key: i,
      ...a,
    });
  });

  return newTag;
};

function codeGenerate(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

const toNested = (data, pid = null) => {
  return data.reduce((r, e) => {
    if (pid == e.parent_id) {
      const object = { ...e };
      const children = toNested(data, e.id);

      if (children.length) {
        object.children = children;
      }

      r.push(object);
    }
    return r;
  }, []);
};

const convertParent = (data) => {
  const arr = [];
  data.forEach((e) => {
    arr.push({
      ...e,
      parent_id: e.parent_id === null ? 0 : e.parent_id,
    });
  });

  return arr;
};

const convertProduct = (products) => {
  const newTag = [];

  products.forEach((product, i) => {
    newTag.push({
      key: product.id,
      label: product.name,
      slice: product.slice,
      price: product.price,
    });
  });

  return newTag;
};

function numberSeparator(x) {
  // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

const storiesItem = (data) => {
  const stories = [];

  data.forEach((story, i) => {
    stories.push({
      url: story.video,
      type: "video",
      duration: 5000,
      header: {
        heading: `نظر ${toFarsiNumber(i + 1)}`,
        profileImage: story.image,
      },
    });
  });

  return stories;
};

const hollandChecker = (data) => {
  // const test = ["10", "63", "3", "56"];
  const newData = {};

  data.forEach((an) => {
    newData[an] = true;
  });

  return newData;
};

const dateObjectConverter = (dates) => {
  const newTag = [];

  dates.forEach((date) => {
    newTag.push({
      date: date,
      name: new Intl.DateTimeFormat("fa-IR", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }).format(new Date(date)),
    });
  });

  return newTag;
};

const mergeArray = (data) => {
  const basic = [];
  const pro = [];
  const max = [];

  // basic
  data[0].features.forEach((item, i) => {
    basic.push({
      code: i,
      basic: item.status === 1 ? true : false,
      ...item,
    });
  });

  // pro
  data.length > 1 &&
    data[1].features.forEach((item, i) => {
      pro.push({
        code: i,
        pro: item.status === 1 ? true : false,
        ...item,
      });
    });

  // max
  data.length > 2 &&
    data[2].features.forEach((item, i) => {
      max.push({
        code: i,
        max: item.status === 1 ? true : false,
        ...item,
      });
    });

  const arrs = [].concat(basic, pro, max);
  const noDuplicate = (arr) => [...new Set(arr)];
  const allIds = arrs.map((ele) => ele.code);
  const ids = noDuplicate(allIds);

  const result = ids.map((id) =>
    arrs.reduce((self, item) => {
      return item.code === id ? { ...self, ...item } : self;
    }, {})
  );

  return result;
};

function convertJalaliToISO(dateString) {
  // تبدیل تاریخ شمسی به میلادی با moment-jalaali
  const gregorianDate = moment(dateString, "jYYYY-jMM-jDD").format(
    "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
  );
  return gregorianDate;
}

const isToday = (dateString) => {
  if (dateString) {
    // گرفتن فقط yyyy-mm-dd از ورودی
    const inputDateOnly = dateString.split(" ")[0];

    // گرفتن yyyy-mm-dd امروز در تایم‌زون لوکال
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const todayDateOnly = `${yyyy}-${mm}-${dd}`;

    return inputDateOnly === todayDateOnly;
  }
};

export {
  isToday,
  convertJalaliToISO,
  mergeArray,
  selectedRankItem,
  dateObjectConverter,
  hollandChecker,
  differenceBy,
  idGenerator,
  toFarsiNumber,
  getWindowSize,
  getFormData,
  translateLabel,
  limitString,
  getChildrens,
  randomColor,
  tagsObject,
  selectedItems,
  ReservedTimes,
  accessObject,
  selectedAccess,
  ticketCatObject,
  addressObject,
  codeGenerate,
  toNested,
  convertParent,
  convertProduct,
  dropDownObject,
  priceObject,
  numberSeparator,
  storiesItem,
};
